import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { File } from './../../models/files/files.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { Textarea } from './../../models/editors/textarea.model';

@Component({
  selector: 'swb-file-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.modal.base.component.html',
  providers: [FormControlService]
})
export class FileDetailComponent extends FormDetailBase<File> implements OnInit {

  public url = 'files';
  protected _saveCallback: Function;

  public get headerTitle(): string {
    return 'Upravit popisky souboru ' + (this.entity ? '<strong>' + this.entity.file_name + '</strong>' : '');
  }

  public get fieldsConfig(): Array<any> {
    return [
      new Textarea({
        key: 'description',
        label: 'Popisek',
        isMultilang: true
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {
    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._saveCallback = () => this._router.navigate([{ outlets: { modal: null } }], {
      relativeTo: this._route.parent
    });
    this._getEntity();
  }

}
